import { render, staticRenderFns } from "./FamilyDataDocuments.vue?vue&type=template&id=630a902d&scoped=true&"
import script from "./FamilyDataDocuments.vue?vue&type=script&lang=ts&"
export * from "./FamilyDataDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyDataDocuments.vue?vue&type=style&index=0&id=630a902d&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a902d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
